import { HIGHLIGHT_CSS_CLASS } from "../constants/table-visualization-types"

export const highlightRoasCell = (val: number) => {
  if (val > 3) {
    return HIGHLIGHT_CSS_CLASS.TOP_10
  } else if (val > 2) {
    return HIGHLIGHT_CSS_CLASS.TOP_20
  } else if (val > 1.5) {
    return HIGHLIGHT_CSS_CLASS.TOP_30
  } else if (val < 0.5) {
    return HIGHLIGHT_CSS_CLASS.BOTTOM_20
  } else if (val < 1) {
    return HIGHLIGHT_CSS_CLASS.BOTTOM_10
  }
  return ""
}

export const highlightCell = (val: number, avgData: Record<string, number>) => {
  const { total, count } = avgData
  if (!count || count === 0) {
    return ""
  }

  const exp = total / count
  const ratio = val / exp

  if (ratio > 2) {
    return HIGHLIGHT_CSS_CLASS.TOP_10
  } else if (ratio > 1.75) {
    return HIGHLIGHT_CSS_CLASS.TOP_20
  } else if (ratio > 1.5) {
    return HIGHLIGHT_CSS_CLASS.TOP_30
  } else if (ratio < 0.1) {
    return HIGHLIGHT_CSS_CLASS.BOTTOM_10
  } else if (ratio < 0.25) {
    return HIGHLIGHT_CSS_CLASS.BOTTOM_20
  } else if (ratio < 0.5) {
    return HIGHLIGHT_CSS_CLASS.BOTTOM_30
  }
  return ""
}
